import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-tab-list',
  templateUrl: './master-tab-list.component.html',
})
export class MasterTabListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
